import { useState } from 'react';
import type { ReviewSampleItem } from '@/api/specifications/specifications.types';

interface SampleItemsProps {
  items: ReviewSampleItem[];
  totalCount: number;
  /** Inline preview length before expanding. */
  preview?: number;
}

/**
 * Shows a comma-separated preview of the first few sample items, with an
 * expand affordance that reveals the full list (capped to whatever the
 * backend returned — usually 5).
 */
export function SampleItems({ items, totalCount, preview = 2 }: SampleItemsProps) {
  const [open, setOpen] = useState(false);

  if (items.length === 0) {
    return <div className="sp-samples"><em>Keine Beispiel-Artikel</em></div>;
  }

  const head = items.slice(0, preview);
  const remaining = Math.max(totalCount - head.length, 0);

  return (
    <div className="sp-samples">
      <span className="sp-samples-list">
        {head.map((it) => it.name).join(', ')}
      </span>
      {remaining > 0 && (
        <button
          type="button"
          className="sp-samples-more"
          onClick={() => setOpen((o) => !o)}
        >
          {open ? 'weniger' : `+${remaining} weitere`}
        </button>
      )}
      {open && (
        <div className="sp-samples-expanded">
          {items.map((it) => (
            <div key={it.id} className="item">
              <code>{it.id}</code>
              {it.name}
            </div>
          ))}
          {items.length < totalCount && (
            <div className="item">
              <em>… und {totalCount - items.length} weitere Artikel</em>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
